import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesBuilding,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionBuildingDto } from './dto.type';

export class QuestionBuildingMapper {
  static dtoToEntity(
    dto: QuestionBuildingDto,
  ): ImpactCo2Answer<ValuesBuilding> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'BUILDING',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        buildingCarbonImpactPerDay: Number.parseFloat(
          dto.buildingCarbonImpactPerDay.toString(),
        ),
        numberOfDaysOfUse: dto.numberOfDaysOfUse,
        hasBuildingImpact:
          dto.numberOfDaysOfUse > 0 ||
          Number.parseFloat(dto.buildingCarbonImpactPerDay.toString()) > 0,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesBuilding>,
    projectId: number,
  ): Omit<QuestionBuildingDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      buildingCarbonImpactPerDay: answer.values.hasBuildingImpact
        ? answer.values.buildingCarbonImpactPerDay
        : 0,
      numberOfDaysOfUse: answer.values.hasBuildingImpact
        ? answer.values.numberOfDaysOfUse
        : 0,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
